// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
  brandName: "SMC Jain School,Shahapur",
    contact: "+91 9448043663 | smcjschool@gmail.com",
    socialLinks: {
      instagram: "https://www.instagram.com/explore/locations/167987497203193/smc-jain-higher-primary-school/",
      whatsapp:   "https://wa.me/yourwhatsapplink",
      youtube:    "https://www.youtube.com/channel/UCHjV39fsSfCTyOxVU63Q_sA/videos",
      facebook:   "https://www.facebook.com/smcjschool/",
      twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
